import type { IDestination, ILocalizedDestinationMap } from '@/shared/api/types/destination-types'

export interface DestinationDTO {
  id: string
  countryId: string
  provinceId: string
  slug: string
  destinationType?: string | null
  centerLat?: string | number | null
  centerLng?: string | number | null
  areaBoundary?: IDestination['areaBoundary']
  banner?: string | null
  thumbnail?: string | null
  isActive: boolean
  localizedData?: ILocalizedDestinationMap | null
  createdAt: string
  updatedAt: string
}

function toNumberOrNull(value: string | number | null | undefined): number | null {
  if (value === null || value === undefined) {
    return null
  }
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null
  }
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : null
}

export function mapDestinationDto(dto: DestinationDTO): IDestination {
  const normalizedCenterPoint = (() => {
    const lat = toNumberOrNull(dto.centerLat)
    const lng = toNumberOrNull(dto.centerLng)
    if (lat === null || lng === null) {
      return null
    }
    return [lng, lat]
  })()

  return {
    id: dto.id,
    countryId: dto.countryId,
    provinceId: dto.provinceId,
    slug: dto.slug,
    destinationType: dto.destinationType ?? null,
    centerPoint: normalizedCenterPoint,
    areaBoundary: Array.isArray(dto.areaBoundary) ? dto.areaBoundary : null,
    banner: dto.banner ?? null,
    thumbnail: dto.thumbnail ?? null,
    isActive: dto.isActive,
    localizedData: dto.localizedData ?? null,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
  }
}
